module.exports = __webpack_public_path__ + "img/activity_31.9286b725.png";